module.exports = __webpack_public_path__ + "img/make.1d65e089.svg";